export enum PresentContentFilterTimeEnum {
  Enabled = 'enabled',
  AnyTime = 'any-time',
}
